import { makeRequest } from 'utils/requestLogger';

// This endpoint clears a student's submission by creating a new one. Student remains in the RT
export default (submissionID) =>
  makeRequest('delete', `/api/submissions/${submissionID}`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/deleteSubmission.js